// usco/src/itr-packlist-parser.ts
var normItem = (s) => s.toUpperCase().replace(/[\s]/g, "");
var foldItem = (s) => normItem(s || "").replace(/\/U$/, "").replace(/\)/g, "J").replace(/[^A-Z0-9]/g, "").replace(/[OD]/g, "0").replace(/[IL]/g, "1").replace(/[SB8]/g, "5").replace(/Z/g, "2").replace(/[GE]/g, "6").replace(/T/g, "7").replace(/J/g, "3").replace(/A/g, "4");

// usco/src/itr-txt.ts
var normItem2 = (s) => (s || "").toUpperCase().replace(/\s+/g, "");
function allocatePackingPos(shipment, invoice) {
  var _a, _b, _c, _d;
  const rows = [];
  const issues = [];
  const pool = /* @__PURE__ */ new Map();
  const invoiced = /* @__PURE__ */ new Map();
  for (const l of invoice || []) {
    const k = normItem2(l.item);
    if (!k) continue;
    if (!pool.has(k)) pool.set(k, []);
    pool.get(k).push({ po: l.po, left: (_a = l.qty) != null ? _a : 0 });
    invoiced.set(k, (invoiced.get(k) || 0) + ((_b = l.qty) != null ? _b : 0));
  }
  const folded = /* @__PURE__ */ new Map();
  for (const k of pool.keys()) folded.set(foldItem(k), k);
  const keyOf = (item) => {
    var _a2;
    const k = normItem2(item);
    return pool.has(k) ? k : (_a2 = folded.get(foldItem(item))) != null ? _a2 : k;
  };
  const packed = /* @__PURE__ */ new Map();
  for (const p of shipment.packages) {
    for (const l of p.lines) {
      const k = keyOf(l.item);
      packed.set(k, (packed.get(k) || 0) + ((_c = l.qty) != null ? _c : 0));
      const base = { udc: p.udc, item: l.item, description: l.description };
      if (!invoice) {
        rows.push({ ...base, qty: l.qty, po: "", note: "" });
        continue;
      }
      const q = pool.get(k);
      if (!q || q.length === 0) {
        rows.push({ ...base, qty: l.qty, po: "", note: "not on the invoice" });
        continue;
      }
      let need = (_d = l.qty) != null ? _d : 0;
      if (need <= 0) {
        rows.push({ ...base, qty: l.qty, po: Array.from(new Set(q.map((x) => x.po))).join(", "), note: "quantity missing" });
        continue;
      }
      let placed = false;
      for (const slot of q) {
        if (need <= 0) break;
        if (slot.left <= 0) continue;
        const take = Math.min(slot.left, need);
        rows.push({ ...base, qty: take, po: slot.po, note: "" });
        slot.left -= take;
        need -= take;
        placed = true;
      }
      if (need > 0) rows.push({ ...base, qty: need, po: placed ? q[q.length - 1].po : Array.from(new Set(q.map((x) => x.po))).join(", "), note: `${need} more than the invoice` });
    }
  }
  if (invoice) {
    const all = /* @__PURE__ */ new Set([...packed.keys(), ...invoiced.keys()]);
    for (const k of all) {
      const a = packed.get(k) || 0, b = invoiced.get(k) || 0;
      if (!packed.has(k)) issues.push({ item: k, packed: 0, invoiced: b, kind: "invoice_only" });
      else if (!invoiced.has(k)) issues.push({ item: k, packed: a, invoiced: 0, kind: "packing_only" });
      else if (Math.abs(a - b) > 1e-4) issues.push({ item: k, packed: a, invoiced: b, kind: "qty" });
    }
    issues.sort((x, y) => x.item.localeCompare(y.item));
  }
  return { rows, issues };
}
function packingRowsNoPo(shipment) {
  const rows = [];
  for (const p of shipment.packages) for (const l of p.lines) rows.push({ udc: p.udc, item: l.item, description: l.description, qty: l.qty, po: "", note: "" });
  return rows;
}
export {
  allocatePackingPos,
  packingRowsNoPo
};
